const getAuthMethodId = (user: any, authMethod: string | null) => {
  if (!user) {
    return null
  }

  if (!authMethod) {
    return null
  }

  // Special handling for oauth methods that may be returned directly from linkedAccounts
  if (authMethod.includes('_oauth')) {
    const oauthType = authMethod.replace('_oauth', '')
    // Try to find the matching direct property
    if (user[oauthType]) {
      // For email-based methods (google, apple)
      if (['google', 'apple'].includes(oauthType)) {
        return user[oauthType]?.email || null
      }
      // For social methods that use handles (twitter, discord)
      if (['twitter', 'discord'].includes(oauthType)) {
        return user[oauthType]?.username || null
      }
      // For other methods, try to use a unique identifier
      return user[oauthType]?.subject || user[oauthType]?.id || null
    }

    // If direct property not found, try to find in linkedAccounts
    if (user.linkedAccounts) {
      const account = user.linkedAccounts.find(acc => acc.type === authMethod)
      if (account) {
        return account.email || account.subject || account.id || null
      }
    }
  }

  // Handle direct methods
  switch (authMethod) {
    case 'email':
      return user.email?.address || null
    case 'google':
    case 'apple':
      return user[authMethod]?.email || null
    case 'twitter':
    case 'discord':
      return user[authMethod]?.username || null
    case 'github':
    case 'linkedin':
    case 'spotify':
    case 'instagram':
    case 'telegram':
    case 'tiktok':
    case 'farcaster':
      return user[authMethod]?.id || user[authMethod]?.username || null
    case 'wallet':
    case 'smart_wallet':
      return user[authMethod]?.address || null
    default:
      // For other types, try to find in linkedAccounts
      if (user.linkedAccounts && Array.isArray(user.linkedAccounts)) {
        const account = user.linkedAccounts.find(acc => acc.type === authMethod)
        if (account) {
          return (
            account.address ||
            account.email ||
            account.subject ||
            account.id ||
            null
          )
        }
      }
      return null
  }
}

export { getAuthMethodId }
